// extracted by mini-css-extract-plugin
export default {"container":"jOb8ZQ","cancellationContainer":"pCg6IN","header":"jMszQ_","title":"K332RU","message":"a4CgtY","limit":"emlk1B","email":"tiVHgI mz-caption","button":"PjlJX1"};